import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { english, french } from './languages'

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: import.meta.env.NODE_ENV === 'development',
        fallbackLng: 'en',
        resources: {
            en: {
                translation: english,
            },
            fr: {
                translation: french,
            },
        },
        interpolation: {
            escapeValue: false,
        },
    })

export default i18next
